<ng-container *ngIf="!finishedLoadingSpinner">
  <app-loading-spinner></app-loading-spinner>
</ng-container>

<div *ngIf="finishedLoadingSpinner">
  <div id="page-container">
    <!-- Page Content -->
    <div class="content content-narrow">
      <!-- Dynamic Table Full -->
      <div class="block">
        <div class="page o-center-page__page">
          <header class="c-header-language">
            <div class="container-fixed">
              <div class="c-header-language__container">
                <div class="c-header-language__logo m-3"></div>
              </div>
            </div>
          </header>
          <main class="o-center-page__main">
            <div
              class="attendance-container-custom mb-3 card p-2 t-elevated-shadow-cap justify-content-center">
              <div>
                <div class="c-texto__titulo mx-2 mt-4 p-2">
                  <div class="text-center">
                    <p class="mb-4">
                      Bienvenido(a) al sistema de registro de asistencia de
                    </p>
                    <img
                      class="m-auto"
                      width="55%"
                      height="55%"
                      class="lazy"
                      src="../../../assets/img/backgrounds/sifca-logo-05-opt.webp"
                      alt="Logo SIFCA" />
                  </div>
                  <h3
                    class="h3-montserrat mt-4 p-1"
                    style="border-top: 1px solid">
                    Registro para el evento:
                  </h3>
                  <ng-container
                    *ngIf="!isSessionDataLoading; else skeletonInput">
                    <h3>
                      {{ nombreCurso }}
                    </h3>
                  </ng-container>
                  <ng-template #skeletonInput>
                    <app-skeleton skeletonType="skeleton-input"></app-skeleton>
                  </ng-template>

                  <h4 *ngIf="eventData">
                    D&iacute;as totales:
                    {{ eventData.totalPartesReales }}
                  </h4>
                  <h4 *ngIf="!isMasterQR">
                    D&iacute;a n&uacute;mero: {{ numeroSesion }}
                  </h4>
                </div>
                <div class="c-texto__contenido mx-2 mt-4">
                  <p>
                    Este es un espacio en el cual podrás registrar tu
                    asistencia, si ya cuentas con tu cuenta institucional da
                    click aquí.
                  </p>
                  <ng-container *ngIf="!isSessionDataLoading; else skeletonBtn">
                    <p>
                      <a
                        class="btn btn-attendance btn-pequeno u-margin-auto"
                        title="Registro AD"
                        (click)="loginAd()"
                        ><span>Registrar asistencia</span></a
                      >
                    </p>
                  </ng-container>
                  <ng-template #skeletonBtn>
                    <div class="m-auto">
                      <app-skeleton skeletonType="skeleton-btn"></app-skeleton>
                    </div>
                  </ng-template>
                </div>
                <div class="c-texto__contenido c-texto__contenido--small">
                  <p>¿Aun no cuentas con cuenta institucional?</p>
                  <p>Ingresa aquí</p>
                  <ng-container *ngIf="!isSessionDataLoading; else skeletonBtn">
                    <p>
                      <a
                        (click)="openModal(modalToOpen)"
                        class="btn btn-secondary-attendance btn-pequeno u-margin-auto"
                        title="Registro"
                        ><span>Invitado</span></a
                      >
                    </p>
                  </ng-container>
                </div>
              </div>
              <article
                data-history-node-id="6"
                role="article"
                about="/node/6"
                class="node node--type-home-page node--view-mode-full clearfix">
                <header></header>
                <div class="node__content clearfix"></div>
              </article>
            </div>
          </main>
          <app-footer></app-footer>
        </div>
      </div>
    </div>
    <!-- END Page Content -->
  </div>

  <!-- Form Modal -->
  <div>
    <ng-template #modalToOpen let-modal>
      <app-modal-register-guest-attendance
        [allowPersonNumber]="true"
        [allowCurp]="true"
        (submitData)="validateDataAndAddAttendant($event)"
        (closeModal)="closeModal()"></app-modal-register-guest-attendance>
    </ng-template>
  </div>
</div>
